
export default {   
    methods: {
        getDataInicial(date){
            let data = new Date()
            let dataInicial = new Date(data.getFullYear() + '-' + (data.getMonth() + 1) + '-1')
            let dataInit = date != null ? new Intl.DateTimeFormat().format(date) : new Intl.DateTimeFormat().format(dataInicial)
            return dataInit
        },

        getDataFinal(date){
            let dataFinal = date != null ? new Intl.DateTimeFormat().format(date) : new Intl.DateTimeFormat().format()
            return dataFinal
        },
    }
}